import { z } from "zod";
import { reminderCadenceSchema, ulidSchema } from "./schemas.js";
// Stable catalog identity only: never place prompt or response content in this slug.
// Three or more segments preserve legacy pr-<category>-NN-NN IDs while allowing
// immutable semantic category/topic/template-family IDs.
export const catalogPromptIdSchema = z
    .string()
    .min(8)
    .max(223)
    .regex(/^pr-[a-z0-9]{1,64}(?:-[a-z0-9]{1,64}){2,15}$/, "Expected a bounded lowercase semantic catalog prompt ID");
export const capturePromptStateSchema = z.enum(["QUEUED", "OPEN", "ANSWERED", "SKIPPED"]);
export const capturePromptSummarySchema = z
    .object({
    promptId: ulidSchema,
    catalogPromptId: catalogPromptIdSchema.nullable().optional(),
    position: z.number().int().nonnegative(),
    question: z.string().trim().min(1).max(1_000),
    assignedTo: ulidSchema.nullable(),
    state: capturePromptStateSchema,
    answeredChapterId: ulidSchema.nullable(),
})
    .strict();
export const captureCadenceSchema = z
    .object({
    cadence: reminderCadenceSchema,
    nextPromptAt: z.string().datetime().nullable(),
    updatedAt: z.string().datetime(),
})
    .strict()
    .superRefine((value, context) => {
    if (value.cadence === "PAUSED" && value.nextPromptAt !== null)
        context.addIssue({
            code: "custom",
            path: ["nextPromptAt"],
            message: "A paused cadence cannot have a next prompt time.",
        });
});
export const captureWorkspaceSchema = z
    .object({
    bookId: ulidSchema,
    cadence: captureCadenceSchema,
    prompts: z.array(capturePromptSummarySchema).max(250),
})
    .strict();
export const updateCaptureCadenceCommandSchema = z
    .object({ cadence: reminderCadenceSchema })
    .strict();
export const captureWorkspaceResponseSchema = z.object({ data: captureWorkspaceSchema }).strict();
//# sourceMappingURL=capture.js.map